import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { capitalizeWholeHint, getFirstTwoLettersCapitalized, processBrandNames } from "components/Shared/Helpers/TextCapitalizer";
import { currencyFormatter } from "components/Shared/Helpers/CurrencyConverter";
import { GetIcon } from "components/Shared/IncServices";
import { AvailableFareSegmentModel, AvailableFareModel } from "WebApiClient";
import _ from "lodash";

interface Props {
    segments: AvailableFareSegmentModel[];
    fare: AvailableFareModel;
    connection: any;
    legIndex: number;
}

const getUniqueBrandNames = (array: AvailableFareSegmentModel[]) => {
    const uniqueBrandNames = new Set();
    const uniqueBrandNameObjects: any[] = [];

    array.forEach((item) => {
        if (!uniqueBrandNames.has(item.brandName)) {
            uniqueBrandNames.add(item.brandName);
            uniqueBrandNameObjects.push(item);
        }
    });

    return uniqueBrandNameObjects;
};

const getUniqueIncludedServices = (data: any) => {
    const uniqueServicesMap = new Map();

    data.forEach((item: any) => {
        item.includedServices.forEach((service: any) => {
            const serviceString = JSON.stringify(service);
            if (!uniqueServicesMap.has(serviceString)) {
                uniqueServicesMap.set(serviceString, service);
            }
        });
    });

    return Array.from(uniqueServicesMap.values());
};

const removeDuplicateServices = (dataArray: any[]) => {
    return dataArray.map(item => {
        const uniqueServices = _.uniqWith(
            item.services as any[],
            (a: any, b: any) =>
                a.type === b.type && a.subType === b.subType && a.hint === b.hint
        );

        return {
            ...item,
            services: uniqueServices
        };
    });
};


export const RenderUpsellContent: React.FC<Props> = ({
    segments,
    fare
}) => {
    const isEconomyGreen = segments.some(segment => segment?.brandName?.toLowerCase().includes("green"));

    return (
        <div className="upSellContent">
            <div className="upSellHeader" style={{
                background: isEconomyGreen ? "#4CAF50" : ""
            }}>
                <p>
                    <span className="ancillaries text-s">
                        {processBrandNames(getUniqueBrandNames(segments)).map((segment, index) => (
                            <span key={`brandName-${index}`}>{segment?.brandName}</span>
                        ))}
                    </span>
                </p>
                <p>
                    <span className="ancillaries text-s">
                        {fare.totalPrice.toFixed(2)} {currencyFormatter(fare.currency)}
                    </span>
                    <span
                        className="ancillaries text-s"
                        style={{
                            fontSize: "10px",
                            fontWeight: "500",
                            float: "right",
                            marginTop: "5px",
                        }}
                    >
                        {getFirstTwoLettersCapitalized(fare.fareInfoBox.queryGDS)}
                    </span>
                </p>
            </div>
            <div className="hoverUpsellIcon">
                <span>
                    {removeDuplicateServices(getUniqueIncludedServices(segments)).map(
                        (mainGroup: any, index: number) => (
                            <span key={`mainService-${index}`} style={{ display: 'flex', alignItems: 'self-start' }}>
                                <span style={{ minWidth: '16px', marginRight: '4px', display: 'flex', alignItems: 'start', paddingTop: '4px' }}>
                                    <FontAwesomeIcon className="upsellIcon" icon={GetIcon(mainGroup)} />
                                </span>
                                <div style={{ lineHeight: '16px' }}>
                                    {capitalizeWholeHint(mainGroup.services)?.map((sub: any, subIndex: number) => (
                                        <span key={`sub-${subIndex}`} style={{ fontSize: '10px' }}>
                                            {sub.hint}
                                            <br />
                                        </span>
                                    ))}
                                </div>
                            </span>
                        )
                    )}
                </span>
            </div>
        </div>
    );
};
